import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { BatchTransaction } from '../types'
import { computed, Ref, ref } from 'vue'

///////////////////////////////////////////////////////////////////////////////
// Utils
///////////////////////////////////////////////////////////////////////////////

const addItem = (items: Ref<Map<string, unknown>>, item: any) => {
  if (!item._cid) {
    items.value.set(item.id.toString(), item)
    return
  }

  items.value.set(item._cid, item)
}

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

type BatchTransactionMap = Map<string, BatchTransaction>
export const useBatchTransactionStore = defineStore('investing/batchTransactionStore', () => {
  const items = ref<BatchTransactionMap>(new Map())
  const batchTransactions = computed(() => Array.from(items.value.keys()).map((key) => items.value.get(key)))

  const fetchBatchTransaction = async (batch_transaction_id: string, { slug }: { slug: string }) => {
    const data = await useFetch(
      `/v4/${slug}/investing/batch-transactions/${batch_transaction_id}`,
    ).get<BatchTransaction>()
    addItem(items, data)
  }

  const issueOperatingActivity = async (payload, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/batch-transactions/issue-operating-activity`).post({
      batch_transaction: payload,
    })
  }

  const issueInterestAllocation = async (payload, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/batch-transactions/issue-interest-allocation`).post({
      interest_allocation: payload,
    })
  }

  const updateOperatingActivity = async (batch_transaction_id: string, payload, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/batch-transactions/${batch_transaction_id}/update-operating-activity`).post({
      batch_transaction: payload,
    })
  }

  const removeBatchTransaction = async (id: string, { slug }: { slug: string }) => {
    await useFetch(`/v4/${slug}/investing/batch-transactions/${id}/remove`).post()
  }

  return {
    items,
    batchTransactions,

    fetchBatchTransaction,
    issueInterestAllocation,
    issueOperatingActivity,
    removeBatchTransaction,
    updateOperatingActivity,
  }
})
